import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// PWA: register the service worker in production builds only (it would interfere
// with Vite's dev HMR). See public/sw.js.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      /* registration is best-effort */
    });
  });
}

// NOTE: intentionally NOT wrapped in <StrictMode>. Strict mode double-invokes
// effects in dev, which would boot+destroy+reboot the Phaser game (and its
// WebGL context) on mount — a known footgun for canvas engines.
const container = document.getElementById('root');
if (!container) throw new Error('#root element not found');
createRoot(container).render(<App />);
